import { render, staticRenderFns } from "./TheMain.vue?vue&type=template&id=74600900&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=ts"
export * from "./TheMain.vue?vue&type=script&lang=ts"
import style0 from "./TheMain.vue?vue&type=style&index=0&id=74600900&lang=scss&scoped=true"
import style1 from "./TheMain.vue?vue&type=style&index=1&id=74600900&scoper=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74600900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74600900')) {
      api.createRecord('74600900', component.options)
    } else {
      api.reload('74600900', component.options)
    }
    module.hot.accept("./TheMain.vue?vue&type=template&id=74600900&scoped=true", function () {
      api.rerender('74600900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheMain.vue"
export default component.exports